export default __webpack_public_path__ + "static/media/4-min.b9ebf7be.jpg";